import { styled } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const StandardTable = styled('table')(({ theme }: { theme: Theme }) => ({
    borderCollapse: 'collapse',
    width: '100%',

    '& th': {
        color: theme.palette.text.disabled,
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'left',
        borderBottom: 'none',
    },

    '& th,td': {
        backgroundColor: theme.palette.background.paper,
        padding: '20px'
    },

    '& tr td': {
        borderBottom: `1px solid ${theme.palette.background.default}`,
        color: theme.palette.text.secondary,

        '&:first-child': {
            color: theme.palette.text.primary,
            fontWeight: 'bold'
        }
    }
}));
